var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import * as React from 'react';
import styled from 'styled-components';
import { InlineChildren, StackChildren, Text, TextStyle, } from '@doordash/design-language';
import { Modal, ModalSize } from '@doordash/component-modal';
import Button from '@doordash/component-button';
import { CalendarStrings } from './CalendarStrings';
var contentStrings = CalendarStrings.deleteConfirmationModal;
var ButtonGroupContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  max-width: 300px;\n"], ["\n  max-width: 300px;\n"])));
var DeleteGroupOrderEntryModal = function (_a) {
    var onClose = _a.onClose, handleOnDeleteEntry = _a.handleOnDeleteEntry;
    var confirmEntryDeletion = function () {
        handleOnDeleteEntry();
        onClose();
    };
    return (React.createElement(Modal, { title: contentStrings.title(), onClose: onClose, size: ModalSize.Large },
        React.createElement(StackChildren, { size: StackChildren.Sizes.Medium },
            React.createElement(Text, { styles: TextStyle.Body1 }, contentStrings.content()),
            React.createElement(InlineChildren, { alignItems: InlineChildren.Alignment.Center, justifyContent: InlineChildren.Justification.FlexEnd },
                React.createElement(ButtonGroupContainer, null,
                    React.createElement(InlineChildren, { alignItems: InlineChildren.Alignment.Center },
                        React.createElement(Button, { type: Button.Types.TertiaryPill, onClick: onClose }, contentStrings.goBackButton()),
                        React.createElement(Button, { type: Button.Types.PrimaryPill, onClick: confirmEntryDeletion }, contentStrings.cancelOrderButton())))))));
};
export default DeleteGroupOrderEntryModal;
var templateObject_1;
